export default __webpack_public_path__ + "static/Atlanta-f8ecbbd9b38cd6bcd6520c9753fb33bc.webp";